import React, { useState, useEffect } from "react";

import Houses from "./houses";
import { getHousePreparedData } from "./utils";

const HousesTree = ({ form, streetObj }) => {
	const { getFieldValue, setFieldsValue } = form;
	const [selectedHouses, setSelectedHouses] = useState([]);
	const [preparedData, setPreparedData] = useState({});

	useEffect(() => {
		const selectedHouses = getFieldValue('addresses').reduce((acc, val, index) => {
			if (val) {
				acc.push(index);
			}

			return acc;
		}, []);
		setSelectedHouses(selectedHouses);
	}, []);

	useEffect(() => {
		const preparedData = getHousePreparedData(
			streetObj,
			selectedHouses,
			setFieldsValue,
			setSelectedHouses
		);
		setPreparedData(preparedData);
	}, [selectedHouses]);

	return (
		<>
			{`Улица ${streetObj?.street}`}
			{preparedData.houses && <Houses houses={preparedData.houses} />}
		</>
	);
};

export default HousesTree;
